<!--
/*******************************************************************************
*@ 컴포넌트명   : StatementInq.vue
*@ 컴포넌트설명 : Statement 조회
*@ 사용전문     : RBF0404D40 - 고객별계좌거래내역발급조회 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 2023.05.31   이가영   베트남 조회기간 FROM TO로 변경
********************************************************************************/
-->
<template>
  <article>
    <div>
      <div class="form">
        <div class="form-row">
          <acno-select-box
            class="form-select-field"
            ref="acno"
            in-acn-knd="0"
            in-acn-dtl-knd="0"
            :value.sync="acno"
            :detail-value.sync="detailValue"
            :label="/*계좌번호*/ $t('MINQ-02-03-01-06')"
            :default-text="/*전체 계좌*/ $t('MINQ-02-03-01-07')"
            :all-option="true"
          />
        </div>
        <div class="form-row">
          <div class="form-select-group">
            <template
              v-if="siteCode != $config.SITECODE_OGMMR && siteCode != $config.SITECODE_OGHCM"
            >
              <select-box
                ref="year"
                :value.sync="selectYear"
                :option-list="selectBoxYear.optionList"
                label-i18n="MINQ-02-03-01-17"
              />
              <select-box
                ref="month"
                :value.sync="selectMonth"
                :option-list="selectBoxMonth.optionList"
                label-i18n="MINQ-02-03-01-15"
              />
            </template>
            <template v-else>
              <calendar-range
                :from-date.sync="fromDate"
                :to-date.sync="toDate"
                :is-show-range-btn="false"
              />
            </template>
          </div>
        </div>
      </div>

      <!-- notice -->
      <panel :title-i18n="/*유의사항*/ $t('MPAY-03-01-01-08')">
        <template #content>
          <ul class="ulist">
            <li>{{ /*고객님이 보유한 전체계좌의 월별 Statement를 인터넷으로 조회 및 인쇄 하실 수 있는 서비스입니다.*/ $t("MINQ-02-03-01-11") }}</li>
            <li
              v-if="siteCode != $config.SITECODE_OGMMR && siteCode != $config.SITECODE_OGHCM"
            >{{ /*Statement 조회를 원하시는 특정연도와 월을 선택하신 후, [조회]버튼을 선택하십시오.*/ $t("MINQ-02-03-01-12") }}</li>
            <li v-else>{{ /*Statement 조회기간을 선택하신 후 [조회]버튼을 눌러주세요. */ $t("MINQ-02-03-01-19") }}</li>
            <li>{{ /*특정 조회기간 또는 계좌별 조회를 원하시는 경우, 거래내역조회 메뉴를 이용하시기 바랍니다.*/ $t("MINQ-02-03-01-13") }}</li>
          </ul>
        </template>
      </panel>
      <article>
        <div class="btn-area--full fixed">
          <button
            class="btn md normal"
            @click="RBF0404D40Call()"
          >{{ /*조회*/ $t("MINQ-02-03-01-14") }}</button>
        </div>
      </article>
    </div>
    <popup :opened.sync="popupOpened" :use-header="true" class="popup">
      <template #content>
        <article class="content-header">
          <div class="title">
            <template v-if="siteCode == $config.SITECODE_OGHCM">
              <h2 v-if="operGroupCd == 'VN1'">{{ $t(`${siteCode}_지점명칭`) }}</h2>
              <h2 v-else>{{ $t(`oghni_지점명칭`) }}</h2>
            </template>
            <template v-else>
              <h2>{{ $t(`${siteCode}_지점명칭`) }}</h2>
            </template>
          </div>
        </article>
        <article class="contents">
          <!--  dl list-->
          <table-box css-type="type2">
            <template #content>
              <template v-if="siteCode == $config.SITECODE_OGHCM">
                <template v-if="operGroupCd == 'VN1'">
                  <dt>{{ /*주소*/ $t("MINQ-02-03-03-02") }}</dt>
                  <dd v-html="$t('ogvtn_지점주소')"></dd>
                  <dt>{{ /*전화번호*/ $t("MINQ-02-03-03-17") }}</dt>
                  <dd>{{ $t("지점별전화번호_ogvtn") }}</dd>
                </template>
                <template v-else>
                  <dt>{{ /*주소*/ $t("MINQ-02-03-03-02") }}</dt>
                  <dd v-html="$t('oghni_지점주소')"></dd>
                  <dt>{{ /*전화번호*/ $t("MINQ-02-03-03-17") }}</dt>
                  <dd>{{ $t("지점별전화번호_oghni") }}</dd>
                </template>
              </template>
              <template v-else>
                <dt>{{ /*주소*/ $t("MINQ-02-03-03-02") }}</dt>
                <dd v-html="$t(`${siteCode}_지점주소`)"></dd>
                <dt>{{ /*전화번호*/ $t("MINQ-02-03-03-17") }}</dt>
                <dd>{{ $t(`지점별전화번호_${siteCode}`) }}</dd>
              </template>
              <template v-if="siteCode == $config.SITECODE_OGIND">
                <dt>E-mail</dt>
                <dd>{{ $t(`이메일_${siteCode}`) }}</dd>
              </template>
              <template v-if="siteCode == $config.SITECODE_OGAUC">
                <dt>SWIFT CODE</dt>
                <dd>CZNBNZ2AXXX</dd>
              </template>
            </template>
          </table-box>
          <!--  end -->
          <div class="breakdown">
            <ul class="breakdown-list">
              <li>
                <div class="divider">
                  <span class="divider-date">
                    {{ /*조회기간*/ $t("MINQ-02-03-03-05") }} :
                    {{
                    siteCode == $config.SITECODE_OGMMR || siteCode == $config.SITECODE_OGHCM
                    ? `${$getGlobalDateFmt(fromDate)} ~ ${$getGlobalDateFmt(toDate)}`
                    : $getGlobalDateFmt(inquryYmd)
                    }}
                  </span>
                </div>
                <div v-if="RBF0404D40.header.length > 0">
                  <ul v-for="(list, k) in RBF0404D40.header" :key="k">
                    <li>
                      <div class="item basic">
                        <div class="tit">{{ /*계좌명*/ $t("MINQ-02-03-03-06") }}</div>
                        <div class="desc">{{ list.prdctOcntryName }}</div>
                      </div>
                      <div v-if="siteCode == $config.SITECODE_OGMMR" class="item basic">
                        <div class="tit">{{ /*예금주명*/ $t("MINQ-01-01-10-06") }}</div>
                        <div class="desc">{{ list.ovsesCustOcntryName }}</div>
                      </div>
                      <div class="item basic">
                        <div class="tit">{{ /*계좌번호*/ $t("MINQ-02-03-03-07") }}</div>
                        <div class="desc">{{ list.acno }}</div>
                      </div>
                      <div class="item basic">
                        <div class="tit">{{ /*통화*/ $t("MINQ-02-03-03-08") }}</div>
                        <div class="desc">{{ list.cncycd }}</div>
                      </div>
                      <div class="item basic">
                        <div class="tit">{{ /*만기일*/ $t("MINQ-02-03-03-09") }}</div>
                        <div class="desc">{{ $getGlobalDateFmt(list.expirYmd) }}</div>
                      </div>
                      <div class="item basic">
                        <div class="tit">{{ /*해지일*/ $t("MINQ-02-03-03-10") }}</div>
                        <div class="desc">{{ $getGlobalDateFmt(list.termiYmd) }}</div>
                      </div>
                      <div class="item balance">
                        <div class="tit">{{ /*전월잔액*/ $t("MINQ-02-03-03-11") }}</div>
                        <div class="desc">
                          <span class="exchange-unit">{{ list.cncycd }}&nbsp;</span>
                          <span class="amount bold" v-html="$num(list.openingBal, null, true)"></span>
                        </div>
                      </div>
                      <div class="item balance">
                        <div class="tit">{{ /*당월잔액*/ $t("MINQ-02-03-03-12") }}</div>
                        <div class="desc">
                          <span class="exchange-unit">{{ list.cncycd }}&nbsp;</span>
                          <span class="amount bold" v-html="$num(list.dpostBal, null, true)"></span>
                        </div>
                      </div>
                    </li>
                  </ul>
                  <div
                    class="info info-etc"
                  >*{{ /*본 화면은 고객편의를 위하여 제공되는 것으로 법적효력이 없습니다.*/ $t("MINQ-02-03-03-13") }}</div>
                </div>
                <div class="empty" v-else>
                  <div class="empty-img">
                    <i class="icon icon-opt-no" />
                  </div>
                  <strong class="empty-text">
                    <td class="none">{{ /*조회 내역이 없습니다.*/ $t("MCOM-0000015") }}</td>
                  </strong>
                </div>
              </li>
            </ul>
          </div>
        </article>
      </template>
      <!-- <template #footer>
        <div class="btn-area--full">
          <button class="btn md icon normal" @click="generatePDF()">
            <i class="icon icon-pdf" />PDF 파일로 다운로드
          </button>
        </div>
      </template>-->
    </popup>
    <pdf-viewer :opened.sync="show" :pdf-url="pdfFileUrl" />
  </article>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import AcnoSelectBox from "@/components/page/common/AcnoSelectBox";
import PdfViewer from "@/components/page/common/PdfViewer";
import Common from "@/components/basic/Common";
export default {
  name: "StatementInq",
  extends: Common,
  components: { AcnoSelectBox, PdfViewer },
  data() {
    return {
      pdfconfig: {
        toolbar: {
          toolbarViewerLeft: { findbar: false },
        },
      },
      yearOpened: false,
      monthOpened: false,
      popupOpened: false,
      selectBoxYear: {
        optionList: [],
      },
      selectBoxMonth: {
        optionList: [],
      },
      //미얀마 or 베트남 아닐 때 YYYYMM 날짜 사용
      selectYear: "",
      selectMonth: "",
      acno: "",
      detailValue: "",
      pdfFileUrl: "",

      show: false,
      //미얀마 or 베트남일 때 from-to 날짜 사용
      fromDate: "",
      toDate: "",
    };
  },
  computed: {
    ...mapFields(["lang", "siteCode", "operGroupCd"]),
    ...mapFields("accounts/statementInq", ["RBF0404D40", "historyList", "uniqueAcno", "inquryYmd"]),
    ...mapGetters("native", ["getNativeAll"]),
  },
  created() {
    this.optionListSet();
  },
  mounted() {
    if (this.siteCode != this.$config.SITECODE_OGMMR && this.siteCode != this.$config.SITECODE_OGHCM) {
      let now = new Date();
      this.selectYear = now.getFullYear();
      this.selectMonth = now.getMonth() + 1;
      this.$refs.year.setValue(this.selectYear);
      this.$refs.month.setValue(this.selectMonth);
    }
  },
  methods: {
    ...mapActions(["actSetLoading"]),
    optionListSet() {
      let now = new Date();
      //year
      let optList = [];
      for (let i = 20; i >= 0; i--) {
        optList.push({
          value: (now.getFullYear() - i).toString(),
          text: (now.getFullYear() - i).toString(),
        });
      }
      this.$set(this.selectBoxYear, "optionList", optList);

      //month
      optList = [];
      for (let i = 1; i <= 12; i++) {
        optList.push({
          value: i.toString().padStart(2, "0"),
          text: i.toString().padStart(2, "0"),
        });
      }
      this.$set(this.selectBoxMonth, "optionList", optList);

      // this.$refs.year.setValue(this.selectYear);
      // this.$refs.month.setValue(this.selectMonth);
    },
    yearInitValue() {
      const data = this.list.length > 0 ? this.list[0] : null;
      if (!_.isNil(data)) this.yearClick(data);
    },
    yearClick(option) {
      this.selectYear = option.value;
      this.yearOpened = false;
    },
    monthClick(option) {
      this.selectMonth = option.value;
      this.monthOpened = false;
    },
    async RBF0404D40Call() {
      let params = {};
      if (this.siteCode == this.$config.SITECODE_OGMMR || this.siteCode == this.$config.SITECODE_OGHCM) {
        params = {
          tranStartYmd: this.fromDate, //거래시작년월일
          tranEndYmd: this.toDate, //거래종료년월일
          acno: this.detailValue.acno, //계좌번호
        };
      } else {
        this.inquryYmd = this.selectYear.toString() + this.selectMonth.toString().padStart(2, "0");
        params = {
          inquryYmd: this.inquryYmd, //조회년월
          acno: this.detailValue.acno, //계좌번호
        };
      }

      /* API_RBF0404D40 - 고객별계좌거래내역발급조회 호출 */
      await this.$post("/account/trnhis/StatementInqPop", params, this.RBF0404D40Suc);
    },
    RBF0404D40Suc(res) {
      this.RBF0404D40 = {
        //고객별계좌거래내역발급조회 결과
        ...res.outItem,
      };
      // this.historyListCall();
      this.popupOpened = true;
    },
    historyListCall() {
      const _this = this;
      let acnoList = [];
      _this.historyList = [];
      _this.uniqueAcno = [];
      for (let data of this.RBF0404D40.historyList) {
        if (_this._.filter(acnoList, { acno: data.acno }).length === 0) {
          _this.uniqueAcno.push({
            acno: data.acno,
          });
        }

        acnoList.push({
          acno: data.acno,
        });

        _this.historyList.push({
          data,
        });
      }
    },
    generatePDF() {
      //pdf다운로드
      window.scrollTo(0, 0);
    },
    down(str) {
      this.pdfFileUrl = URL.createObjectURL(str);
      if (process.env.VUE_APP_API_CALL != "local") {
        switch (this.getNativeAll.smphMchtlDstcd) {
          case this.$config.OS_ANDROID:
            this.$bridge.fileDownload(this.pdfFileUrl);
            break;
          case this.$config.OS_IOS:
            this.$bridge.goURL(this.pdfFileUrl);
            break;
        }
      }
      this.$log.info(this.pdfFileUrl);
      // this.show = true;
    },
    hasGenerated() {
      this.actSetLoading(true);
    },
    pregress(e) {
      if (e == 100) {
        this.actSetLoading(false);
      }
    },
  },
};
</script>
